var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("status",function(){return [_c('v-badge',{attrs:{"dot":"","color":_vm.state ? _vm.getColor(_vm.state) : null,"inline":"","left":""}}),_vm._v(_vm._s(_vm.state)+" ")]},{"mode":_vm.mode})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }